import React, { FC } from "react";
import { CardContainer, Content, DateBadge, Preview } from "./styles";
import { COLORS } from "@/constants";
import { Typography } from "@mui/material";

type CardType = {
  img: string;
  title?: string;
  desc?: string;
  date?: string;
};

type CardProps = {
  data: CardType;
};

export const Card: FC<CardProps> = ({ data }) => {
  return (
    <CardContainer>
      <Preview>
        <img src={data.img} alt="blog-preview-image" />
        {data.date && (
          <DateBadge>
            <Typography fontSize={12} fontWeight={600} color={COLORS['blue']}>
              {data.date}
            </Typography>
          </DateBadge>
        )}
      </Preview>

      <Content>
        <Typography fontSize={18} fontWeight={{ xs: 600, sm: 600, md: 500 }} lineHeight={1.4} color={COLORS["blue-light"]}>
          {data?.title}
        </Typography>
        <Typography fontSize={14} fontWeight={{ xs: 600, sm: 700, md: 500 }} lineHeight={1.4} color={COLORS["gray"]}>
          {data?.desc}
        </Typography>
      </Content>
    </CardContainer>
  );
};
